import { render, staticRenderFns } from "./AddMealButton.vue?vue&type=template&id=557baf04&scoped=true&"
import script from "./AddMealButton.vue?vue&type=script&lang=js&"
export * from "./AddMealButton.vue?vue&type=script&lang=js&"
import style0 from "./AddMealButton.scss?vue&type=style&index=0&id=557baf04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557baf04",
  null
  
)

export default component.exports